// extracted by mini-css-extract-plugin
export default {"anim_circle":"styles-module__anim_circle___R1UAP"};